import React, {memo} from "react";
import {ReactComponent as Chevron} from "ui-components-rollup/src/images/monochrome-icons/ic-chevron.svg";
import commonStyles from "../../styles/common.module.scss";
import styles from "./InfoItem.module.scss";
import ExternalLink from "../../../../components/widgets/ExternalLink";

export default memo(({ openDialog, text, withChevron, withModal, linkText, href, modalButtonText }) => {
    return (
        <div className={styles["container"]}>
            {withChevron && <Chevron/>}
            <div>
                <span className={styles["text"]}>{text}</span>
                {linkText && <ExternalLink className={commonStyles["in-text-button"]} href={href} newTab>{linkText}</ExternalLink>}
                {withModal && <button className={commonStyles["in-text-button"]} onClick={() => openDialog()}>{modalButtonText}</button>}
            </div>
        </div>
    );
});
